<script>
  export let icon;
  export let stroke = "none";
  export let fill = "#1f363d";
  export let reverse = false;
  export let big = false;
  export let large = false;
  export let medium = false;
  export let small = false;
  export let inline = false;

  if (reverse) {
    const newStroke = fill;
    const newFill = stroke;
    stroke = newStroke;
    fill = newFill;
  }
</script>

<svg
  class="icon"
  class:inline
  class:small
  class:medium
  class:large
  class:big
  {fill}
  {stroke}
  on:click
  viewBox="-1 -1 26 26"
>
  <use xlink:href="#{icon}" />
</svg>

<style>
  .icon {
    display: block;
    width: 24px;
    height: 24px;
    margin: 5px;
  }

  .big {
    width: 48px;
    height: 48px;
  }

  .large {
    width: 36;
    height: 36;
  }

  .small {
    width: 12px;
    height: 12px;
  }

  .medium {
    width: 18px;
    height: 18px;
  }

  .inline {
    margin: 0;
    display: inline;
  }
</style>
